<template>
  <div class="empower">
    <head-top head-title="协议" goBack="true"></head-top>
    <!--使用协议-->
    <div class="empower_main" v-if="type === 'use'">
      <div class="letter_title">
        <span>业主在线服务使用协议</span>
      </div>
      <div class="one_section">
        <h3>[特别提示]</h3>
        <div class="section_text">
					<span>鉴于您（以下亦可称为“本人”）申请使用业主在线（包括业主在线公众号和点我投小程序）平台所提供的认证服务，为了您在业务活动中操作流程更简便，
					遵守国家关于身份信息认证(以下可统称“实名认证”)的规定以及业主在线平台与您之间关于实名认证达成的约定，保护您的合法权益，您在此同意向杭州中正物联物业服务评估监理有限公司(以下可简称“杭州中正”)及本服务协议中约定的相关主体(以下亦可统称为“我们”或“我司”)出具本《业主在线服务使用协议》
					(以下简称“《服务协议》”)。本《服务协议》项下的授权是您依法自愿作出的独立授权。</span>
        </div>
        <ul>
          <li>
            <span>（1）为了维护您的合法权益，请您仔细阅读《服务协议》，为了提醒您特别注意，我们已经对该部分条款予以加粗、加下划线等方式对您特别提示。</span>
          </li>
          <li>
						<span>（2）您一经使用杭州中正提供的服务或者业务活动，即应被视为您已经仔细阅读、完全理解本《服务协议》的内容以及法律后果，并对我们做出的本
						《服务协议》载明的授权。如果您对本《服务协议》以及杭州中正提供的服务有任何的问题，请随时与我们取得联系。</span>
          </li>
          <li>
						<span>
							（3）为方便您理解本《服务协议》的内容，对相关定义做如下说明:数据源，指合法持有您的身份信息并依法向杭州中正提供实名认证比对结果的主体，包括:(a)依法运营政府部门数据库的主体，包括各级行政机关、政府部门、公共管理部门、司法机关、公共信用信息管理部门等主体;(b)依法运营商业化数据库的主体，包括电信运营商、金融机构等企事业单位。具体以杭州中正实际合作情况为准。
							<br/>▪ 身份信息，指您的姓名、国籍、性别、学历学籍、职业、住址、联系方式、电话以及您有效身份证件的种类、号码和有效期限等能够依法识别您身份的个人信息。
						</span>
          </li>
          <li>
						<span>
							一、为了遵守国家关于实名认证的相关规定，本人同意在业务活动中向业主在线平台提交本人的身份信息；本人授权业主在线平台收集本人身份信息后提交给杭州中正进行实名认证处理;本人授权杭州中正可采集本人身份信息对其进行整理、保存、分析、比对、核实、校验、加工并授权杭州中正可向数据源提供本人身份信息进行实名认证处理;本人授权数据源可对本人身份信息进行比对、核实、校验、加工等处理并提供比对结果至杭州中正，本人授权杭州中正向业主在线平台提供比对结果。
						</span>
          </li>
          <li>
            <span>二、为了本人能够持续、及时地进行实名认证，本人在确认前述第一条授权的基础上，同时授权数据源可根据本人身份信息的任何补充及更新所作出的比对结果及时提供给杭州中正;同时授权杭州中正可直接向数据源采集本人身份信息的任何补充及更新内容所作出的比对结果。本人授权，杭州中正可对其进行整理、保存、分析、比对、核实、校验、加工后用于实名认证目的，提供给业主在线平台使用。</span>
          </li>
          <li>
            <span>三、杭州中正提供的服务仅供本人及业主在线平台参考,是否通过实名认证由业主在线平台自行决定，杭州中正对业主在线平台作出的判断、决定以及所从事的活动等行为及其任何后果不承担任何法律责任。</span>
          </li>
          <li>
            <span>四、本人在认证时提交给业主在线平台的认证资料，即不可撤销的授权由业主在线平台保留。业主在线平台承诺除法定或约定的事由外，不公开或编辑或透露本人的认证资料及保存在业主在线平台的非公开内容用于商业目的，但下列情况除外:</span>
            <div class="special_tip">
              <p>a)本人授权业主在线平台透露的相关信息;</p>
              <p>b)业主在线平台向国家司法及行政机关提供;</p>
              <p>c)第三方和业主在线平台一起为用户提供服务时，该第三方向本人提供服务所需的相关信息。</p>
            </div>
            <span>杭州中正将采取合理的方式以保护本人个人资料的安全。杭州中正将使用必要的可以获得的安全技术和程序来保护本人的个人资料不被未经授权的访问、使用或泄漏。</span>
          </li>
          <li><span class="weight_text">五、若本人与杭州中正发生任何纠纷或争议，首先应友好协商解决;协商不成的，本人同意将纠纷或争议提交本《服务协议》签订地(即中国浙江省杭州市拱墅区)有管辖权的人民法院管辖。本《服务协议》签订地为中华人民共和国浙江省杭州市拱墅区。 本人已知悉本《服务协议》所有内容(特别是加粗字体内容)的意义以及由此产生的法律效力，自愿作出上述授权，本《服务协议》是本人真实的意思表示，本人同意承担由此带来的相关法律后果。</span></li>
          <li>
            <span>特此授权!</span>
          </li>
        </ul>
      </div>
    </div>

    <!--隐私协议-->
    <div class="empower_main" v-if="type==='hide'">
      <div class="hide_part">
        <h2>隐私声明</h2>
        <div class="hide_text">
          <span>欢迎访问业主在线（包括业主在线公众号和点我投小程序）以下可简称本系统，业主在线尊重以及保护用户隐私。本《隐私声明》(也称"本声明")为本系统有关收集、储存、使用和披露使用者(也称"您")个人信息的原则和规定的声明。在使用者接受《隐私声明》时，使用者即已经表示同意受本《隐私声明》的约束。</span>
        </div>
        <ul class="hide_ul">
          <li>
						<span>
							一、信息采集自愿<br/>
							本系统可能需要使用者提供姓名、名称、电话、电子邮箱、通讯地址、相关人员职位、教育程度、职业等个人化信息资料，使用者有权拒绝提供相关信息而停止使用本系统。
						</span>
          </li>
          <li>
						<span>二、合理使用所采集信息<br/>
							使用者在提供或允许被采集信息时即表示愿意本系统在以下必要范围内合理使用所采集的使用者的个人信息:</span>
            <div class="special_tip">
              <p>1、使用采集的信息来获得账户的统计资料，并根据统计对账户进行分类、联系等，以有针对性为账户提供新的服务机会;</p>
              <p>2、使用采集的信息为使用者提供相关的服务，分析、确认的过程和结果，查核相应身份、资格及信用情况，处理可能的相关法律争议;</p>
              <p>3、使用采集信息进行市场分析，以制定产品或服务的生产、市场计划等;</p>
              <p>4、使用采集的资料来跟踪使用者的IP地址，跟踪的目的仅仅是为了安全的必要。如果未发现安全问题，本系统会及时删除收集到得IP地址。</p>
              <p>5、使用采集的信息来统计本系统全天的页面访问数据，以更好地预测本系统未来流量及制定相应的发展计划。</p>
              <p>6、允许为本系统提供技术、服务、维修或其它合作项目的任何第三方为提供相应服务或履行相应义务而合理地使用被采集的信息。</p>
              <p>7、本系统为履行其义务或改进服务所必须的使用;</p>
              <p>8、其它相关法律规定许可、需要使用的情况下的使用。</p>
            </div>
          </li>
          <li>
						<span>三、限制使用所采集信息<br/>
						除本声明第二条规定的必要范围内的合理使用外，本系统不会以其他形式使用所采集的信息，也不会出租、出售、或泄漏所采集的信息。但在已取得使用者的书面同意、为免除使用者的生命或身体或财产方面的急迫危险、为防止第三方利益的重大危险或为增进公共利益且无害于使用者的重大利益、以及在法律法规许可或强制要求等情况下，本系统可对所采集的信息进行上述必要范围以外的使用。</span>
          </li>
          <li>
						<span>四、相对安全<br/>
						本系统对采集的信息进行严格的管理和保护，本系统使用相应及合适的技术以防止使用者的资料和信息丢失，被盗用或被篡改，包括向其它服务器备份数据或对使用者密码加密等。尽管本系统有这些安全措施，但鉴于技术限制及因特网本身的性质，我们只能说所采集信息会相对安全，请注意因特网上不存在“完善的安全措施”。</span>
          </li>
          <li>
						<span>五、关于Cookie<br/>
						本系统设有Cookie，目的是为了对使用者更友好、使使用者的操作更方便以及为使用者提供更加个人化的服务。Cookie是一种技术，当使用者访问设有Cookie的本系统时，本系统
						会自动将Cookie发送到使用者的浏览器并储存到使用者的电脑硬盘，该Cookie便负责记录使用者其后访问和使用本系统的种种活动、个人资料、浏览习惯、消费习惯、包括信用记录，为了提高本系统的总体服务质量。使用者在接受本协议时，已经留意并接受了本系统设有Cookie的事实及Cookie的使用性质和状态。</span>
          </li>
          <li>
						<span>六、未成年人的特别注意事项<br/>
						如果您未满18周岁，您所享受到的服务将受到限制，因此我们希望您不要向我们提供任何个人信息。如果您未满18周岁，您只能在父母或监护人的陪同下才可以使用本公司服
						务。</span>
          </li>
          <li>
						<span>七、本系统免责<br/>
						因使用者本人的过失或过错(如泄漏或与第三方分享密码等)、计算机病毒影响、黑客侵入、政府法律法规允许或强制要求网站披露使用者信息的情形、或由于与本系统链接的其它网站的原因或其它不可抗力等原因和因素而引起的所采集使用者个人信息的泄露、丢失、盗用、篡改等以及相关法律争议和后果等，本系统不承担任何责任。使用者在接受本协议时，已经同意本系统免责的规定。</span>
          </li>
          <li>
						<span>八、生效、解释和修改<br/>
						本隐私政策随时都可能修改。未经你明示同意，我们不会削弱你按照本隐私权政策中所应享有的权利，我们会在本页上发布对隐私权政策所做的任何修改。</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../header/Header.vue'
  export default {
    name: 'Empower',
    data () {
      return {
        type: '' // 区分使用协议和隐私协议
      }
    },
    created() {
      // console.log(this.$route.params.type)
      this.type = this.$route.params.type
    },
    methods: {},
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .empower{
    width: 100%;
    padding-top: 40px;
    background: #fff;
    .empower_main{
      padding: 10px;
      .letter_title{
        text-align: center;
        span{
          font-size: 17px;
        }
      }
      .one_section{
        margin-top: 20px;
        h3{
          font-size: 16px;
          font-weight: bold;
        }
        .section_text{
          text-indent: 40px;
          margin-top: 10px;
          span{
            font-size: 15px;
            line-height: 25px;
            color: #333333;
          }
        }
        ul{
          li{
            margin-top: 20px;
            span{
              font-size: 15px;
              line-height: 25px;
              color: #333;
            }
            .weight_text{
              font-weight: bold;
            }
            .special_tip{
              p{
                font-size: 15px;
                line-height: 25px;
                color: #333;
              }
            }
          }
        }
      }
      .hide_part{
        h2{
          font-size: 15px;
        }
        .hide_text{
          font-size: 15px;
          margin-top: 20px;
          line-height: 25px;
        }
        .hide_ul{
          font-size: 15px;
          margin-top: 20px;
          line-height: 25px;
          li{
            margin-bottom: 25px;
            .special_tip{
              p{
                font-size: 15px;
                line-height: 25px;
                color: #333;
              }
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/my/Empower.vue